import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HomeService } from 'src/app/shared/services/home.service';

@Component({
  selector: 'app-recent-updates-modal',
  templateUrl: './recent-updates-modal.component.html',
  styleUrls: ['./recent-updates-modal.component.scss'],
  standalone: false
})
export class RecentUpdatesModalComponent implements OnInit {
  updateEntryForm: UntypedFormGroup;
  mode: string;
  constructor(
    public dialogRef: MatDialogRef<RecentUpdatesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private homeService: HomeService
  ) {}

  ngOnInit(): void {
    this.data ? (this.mode = 'EDIT') : (this.mode = 'ADD');
    this.updateEntryForm = new UntypedFormGroup({
      title: new UntypedFormControl(this.data ? this.data.release.title : '', Validators.required),
      link: new UntypedFormControl(this.data ? this.data.release.link : '', Validators.required),
      description: new UntypedFormControl(
        this.data ? this.data.release.description : '',
        Validators.required
      ),
      postingDate: new UntypedFormControl(
        this.data ? this.data.release.postingDate : '',
        Validators.required
      )
    });
  }

  onDelete(): void {
    this.homeService.deleteRelease(this.data.release.id).subscribe(() => {
      this.dialogRef.close(true);
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.updateEntryForm.valid) {
      var releaseData = this.updateEntryForm.value;
      if (this.mode === 'EDIT') {
        this.homeService.updateRelease(this.data.release.id, releaseData).subscribe(() => {
          this.dialogRef.close(releaseData);
        });
      } else {
        this.homeService.createRelease(releaseData).subscribe(() => {
          this.dialogRef.close(releaseData);
        });
      }
    }
  }
}
